import type { CSSObject, Theme } from '@mui/material/styles';

export const PANEL_HEADER_MIN_HEIGHT = 32;

export const getPanelSurfaceStyles = (theme: Theme): CSSObject => ({
  borderRadius: theme.spacing(1),
  boxShadow: theme.shadows[2],
  overflow: 'hidden',
});

export const getPanelHeaderStyles = (theme: Theme): CSSObject => ({
  padding: theme.spacing(0.75, 2),
  minHeight: PANEL_HEADER_MIN_HEIGHT,
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[900] : theme.palette.grey[100],
});

export const getPanelBodyStyles = (theme: Theme): CSSObject => ({
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[1000] : theme.palette.common.white,
});
